import React from 'react';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

const WindowNotes = ({ notes }) => (
  <div className="itemProduct">
    {map(note => (
      <div className="windowNote" key={note.id}>
        <h5>Window Note</h5>
        <div>
          <p className="noteAuthor">{note.author} ({note.authorRole})</p>
          <p className="noteDate">{format(note.date, 'MMMM DD, YYYY')}</p>
        </div>
        <p>{note.content}</p>
      </div>
    ))(notes)}
  </div>
);

WindowNotes.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    authorRole: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  })).isRequired,
};

export default WindowNotes;
